import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, startWith, switchMap, tap } from 'rxjs/operators';
import { IProvider } from '../option-items-providers';

export interface IOptionItem {
  name: number | string;
  label: string;
}

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    NgClass,
    MatAutocomplete,
    MatOption,
    NgForOf,
    AsyncPipe
  ],
  styles: [` input {
      width: 100%;
  }

  .mat-form-field-autofill-control {
      margin-right: 14px;
  }

  .clear-input input {
      margin-bottom: 9px;
      margin-right: 14px;
  }`]
})
export class AutocompleteComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() selectedOptionControl: FormControl;
  @Input() componentId = 'KPAutoCompleteId';
  @Input() placeholder = 'Choose a field...';
  @Input() titleTooltip: string;
  @Input() inputRequired = false;

  private clearInput$: Subscription;
  @Input() clearInputListener: Observable<void>;

  @Output() inputCleared = new EventEmitter();

  optionsControl: FormControl;
  filteredOptions$: Observable<IOptionItem[]>;
  searching = false;

  @ViewChild('optionInput') optionInput: HTMLElement;

  private optionsProvider: IProvider<IOptionItem>;

  ngOnInit() {
    this.optionsControl = new FormControl({disabled: !this.selectedOptionControl || this.selectedOptionControl.disabled}, this.inputRequired ? Validators.required : null);

    this.filteredOptions$ = this.optionsControl.valueChanges.pipe(
      debounceTime(400),
      startWith(''),
      tap(_ => this.searching = true),
      switchMap(value => this.optionsProvider ? this.optionsProvider.filter(value) : of([])),
      tap(_ => this.searching = false),
      tap(result => console.log(`${this.componentId}: options.valueChange results`, result.length))
    );
  }

  ngAfterViewInit() {
    if (this.clearInputListener)
      this.clearInput$ = this.clearInputListener.subscribe(() => this.clearInput(this.optionInput, false));
  }

  setOptionsProvider(optionsProvider: IProvider<IOptionItem>, selOption?: any): void {
    this.optionsProvider = optionsProvider;
    this.optionsControl.setValue(selOption ? selOption : '');   // trigger a value change causing the dropdown to be populated
  }

  clearOption(): void {
    this.optionsControl.setValue('');
  }

  optionDisplayValue(name: any): string {
    const option = this.optionsProvider ? this.optionsProvider.get(name) : null;
    this.titleTooltip = option ? option.label : 'Search...';
    return option ? option.label : '';
  }

  optionSelected(e: MatAutocompleteSelectedEvent): void {
    this.selectedOptionControl.setValue(e.option.value);
    this.selectedOptionControl.markAsDirty();
  }

  clearInput(inputElement: HTMLElement, focusInput: boolean): void {
    this.optionsControl.setValue('');
    if (focusInput)
      inputElement.focus();
    this.selectedOptionControl.setValue('');
    this.inputCleared.emit();
  }

  forceShowOptionsDropDown(event): void {
    event.target.blur();
    event.target.focus();
  }

  ngOnDestroy() {
    if (this.clearInput$)
      this.clearInput$.unsubscribe();
    console.log(`${this.componentId} ngOnDestroy`);
  }
}
